// @core/api/endpoints/notifications/get_notification_stats.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetNotificationStatsResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Get notification statistics
 * Returns aggregated notification statistics including delivery rates, read rates, and channel performance metrics over the specified time period.
 */
export async function GetNotificationStats(
  params?: {
  },
  options?: RequestOptions
): Promise<GetNotificationStatsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics/stats`;
  const requestOptions = options;
  return client.get<GetNotificationStatsResponse>(requestPath, { ...requestOptions, params });
}
